import React from 'react';
import { Box, TextField, FormControlLabel, Checkbox, Typography, Link, IconButton, InputAdornment } from '@mui/material';
import { Visibility, VisibilityOff } from '@mui/icons-material';
import { colors, fonts, spacing } from '../../../constants';
import {
  textFieldStyles,
  passwordFieldWrapperStyles,
  passwordToggleButtonStyles,
  rememberMeRowStyles,
  checkboxStyles,
  rememberMeLabelStyles,
  forgotPasswordLinkStyles,
} from '../../../constants/manualLogin';

/**
 * LoginFormFields Component
 * Contains email field, password field, remember me checkbox, and forgot password link
 */
const LoginFormFields = ({
  formData,
  showPassword,
  loading,
  emailInputRef,
  onChange,
  onTogglePassword,
  onRememberMeChange,
}) => {
  return (
    <>
      {/* Email Input */}
      <TextField
        inputRef={emailInputRef}
        fullWidth
        name="email"
        type="email"
        value={formData.email}
        onChange={onChange}
        required
        disabled={loading}
        size="small"
        placeholder="Email address *"
        sx={textFieldStyles}
      />

      {/* Password Input */}
      <Box sx={passwordFieldWrapperStyles}>
        <TextField
          fullWidth
          name="password"
          type={showPassword ? 'text' : 'password'}
          value={formData.password}
          onChange={onChange}
          required
          disabled={loading}
          size="small"
          placeholder="Password *"
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton
                  aria-label="toggle password visibility"
                  onClick={onTogglePassword}
                  edge="end"
                  sx={passwordToggleButtonStyles}
                >
                  {showPassword ? <VisibilityOff /> : <Visibility />}
                </IconButton>
              </InputAdornment>
            ),
          }}
          sx={textFieldStyles}
        />
        {/* Remember Me and Forgot Password */}
        <Box sx={rememberMeRowStyles}>
          <FormControlLabel
            control={
              <Checkbox
                checked={formData.rememberMe}
                onChange={(e) => onRememberMeChange(e.target.checked)}
                name="rememberMe"
                sx={checkboxStyles}
              />
            }
            label={<Typography sx={rememberMeLabelStyles}>Remember me</Typography>}
          />
          {/* <Link
            to="/forgot-password"
            style={forgotPasswordLinkStyles}
            onMouseEnter={(e) => {
              e.target.style.color = colors.primaryHover;
            }}
            onMouseLeave={(e) => {
              e.target.style.color = colors.primary;
            }}
          >
            Forgot password?
          </Link> */}
        </Box>
      </Box>
    </>
  );
};

export default LoginFormFields;
